import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { parseApiErrorMessage } from '../../apiHooks/utils';

interface IProps {
    message?: string;
    apiError?: FetchBaseQueryError | SerializedError;
}

export default function ErrorBanner(props: IProps): JSX.Element {
    const { message, apiError } = props;
    return (
        <div className='bg-red-400/10 p-3 text-center'>
            <div className='inline-flex items-center font-normal text-red-700 w-full'>
                <ExclamationCircleIcon className='size-5 left-0' />
                <div className='text-center w-full'>
                    <p>{message ?? ''}</p>
                    {apiError && <p>{parseApiErrorMessage(apiError)}</p>}
                </div>
            </div>
        </div>
    );
}
